(function () {
  document.querySelectorAll('product-info[data-secim-bekliyor]').forEach((urun) => {
    const buton = urun.querySelector('.product-form__submit');
    const yazi = buton && buton.querySelector('span');

    urun.querySelectorAll('[data-secim-gerekli] input[type="radio"]').forEach((girdi) => {
      girdi.checked = false;
    });

    if (buton) {
      buton.setAttribute('disabled', 'disabled');
      buton.setAttribute('aria-disabled', 'true');
      if (yazi && urun.dataset.secimMetni) yazi.textContent = urun.dataset.secimMetni;
    }

    urun.addEventListener('change', function secildi(e) {
      if (!e.target.closest('[data-secim-gerekli]')) return;
      urun.removeAttribute('data-secim-bekliyor');
      if (buton) buton.removeAttribute('aria-disabled');
      urun.removeEventListener('change', secildi);
    });
  });
})();
